import { Dispatch, SetStateAction } from 'react';
import Modal from '../modal/Modal';
import { BoldText, RegularText } from '../../lib/Text';
import { Col, Row } from '../../lib/utils';
import { colors } from '../../lib/colors';
import Dot from '../Dot';
import NewColorSquareButton from '../Button/NewColorSquareButton';

type Props = {
    setIsVisible: Dispatch<SetStateAction<boolean>>;
};

const ModalDeleteError = ({ setIsVisible }: Props) => {
    return (
        <Modal setIsVisible={setIsVisible} whiteViewWidth={629} borderRadius={25}>
            <Col className="flex py-[35px] px-[35px]">
                <BoldText fontSize={28} lineHeight={35} color={colors.Text_1} className="mb-[28px]">
                    수강권을 삭제할 수 없어요!
                </BoldText>
                <Row className="flex items-center mb-[16px]">
                    <Col>
                        <Dot className="mx-[8px]" />
                    </Col>
                    <RegularText fontSize={20} lineHeight={30} color={colors.Text_1}>
                        해당 수강권으로 사용된 수업 일정이 있어 삭제할 수 없어요
                    </RegularText>
                </Row>
                <Row className="flex items-start">
                    <Col>
                        <Dot className="mx-[8px] mt-[16px]" />
                    </Col>
                    <RegularText fontSize={20} lineHeight={30} color={colors.Text_1} letterSpacing={-0.3}>
                        {`이 수강권으로 만든 스케줄을 모두 삭제하거나 다른 수강권으로 변\n경하셨다면 삭제할 수 있어요. (※사용 기록이 없고, 삭제 전 만료\n처리 필요)`}
                    </RegularText>
                </Row>
                <Row className=" self-end mt-[40px]">
                    {/* <Col
                        className=" justify-center items-center bg-[#F2F4F6] w-[120px] h-[50px] rounded-[10px] mr-[18px] cursor-pointer"
                        onClick={() => setIsVisible(false)}
                    >
                        <RegularText fontSize={20} lineHeight={30} color={colors.Text_1}>
                            취소
                        </RegularText>
                    </Col> */}
                    <Col
                        className=" justify-center items-center bg-primary w-[120px] h-[50px] rounded-[10px] cursor-pointer "
                        onClick={() => setIsVisible(false)}
                    >
                        <RegularText fontSize={20} lineHeight={30} color={colors.white}>
                            확인
                        </RegularText>
                    </Col>
                </Row>
            </Col>
        </Modal>
    );
};
export default ModalDeleteError;
